export const getPersonTypeTranslate = (personType: string) => {
  switch (personType) {
    case 'natural_person':
      return 'Pessoa Física'

    case 'legal_person':
      return 'Pessoa Jurídica'

    case 'international_person':
      return 'Internacional'

    case '':
      return 'Não especificado'

    default:
      return 'Não especificado'
  }
}
